
import { Observable } from './druid/./druid/Observable';
import { map } from './druid/./druid/operator/map';

Observable.prototype.map = map;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    map: typeof map;
  }
}